import { Checkbox, FormControlLabel } from "@mui/material";
import React, { type FC, type ReactNode } from "react";
import clsx from "clsx";
import { isArray } from "lodash";
import "./GenericCheckbox.scss";
import { isMobile } from "react-device-detect";
import { CheckboxIcon } from "@shared/frontend/icons";

interface GenericCheckboxProps {
  value: string | string[];
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  text: string;
  buttons: {
    label: string;
    name: string;
    description?: string;
    icon?: ReactNode;
    onClick?: React.MouseEventHandler<HTMLLabelElement>;
  }[];
  fontSize?: string;
  className?: string;
  labelClassName?: string;
}

export const GenericCheckbox: FC<GenericCheckboxProps> = ({
  value,
  text,
  handleChange,
  buttons,
  className,
  labelClassName,
}) => {
  return (
    <div className={clsx("three-checkbox-container", className && className)}>
      {text && <p className={clsx("checkbox-label", labelClassName)}>{text}</p>}
      <div className={clsx("checkbox-container", isMobile && "small")}>
        {buttons.map((button, index) => {
          return (
            <React.Fragment key={index}>
              <FormControlLabel
                onClick={button.onClick}
                control={
                  <Checkbox
                    checkedIcon={<CheckboxIcon checked />}
                    icon={<CheckboxIcon />}
                    name={button.name}
                    onChange={(e) => handleChange(e)}
                  />
                }
                label={button.label}
                checked={
                  value === button.name ||
                  (value.includes(button.name) && isArray(value))
                }
              />
              {index !== buttons.length - 1 && <div className="line" />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
